export function handleLayoutChangedEvent(event) {
	if (actualGridLayoutSettingsId > 0) {
		$('#grid-save-columns-form input').val($('#grid-layout-' + actualGridLayoutSettingsId).html());
	} else {
		$('#grid-save-columns-form input').val('');
	}
}

export function setLayout(val) {
	if (val === 'default') {
		actualGridLayoutSettingsId = null;
		gridSettings.api.setSortModel(null);
		gridSettings.columnApi.resetColumnState();
		gridSettings.columnApi.resetColumnGroupState();
	} else {
		var layoutModel = $('#grid-layout-' + val).data('layout');
		actualGridLayoutSettingsId = val;

		if (layoutModel) {
			gridSettings.api.setSortModel(layoutModel.sorting);
			gridSettings.columnApi.applyColumnState({
					state: layoutModel.columns,
			});
			gridSettings.columnApi.setColumnGroupState(layoutModel.groups);
		}
	}
}

window.setLayout = setLayout;

export function saveGridLayout() {
	let sortModel = gridSettings.api.getSortModel();
	let columnState = gridSettings.columnApi.getColumnState();
	let columnGroupState = gridSettings.columnApi.getColumnGroupState();

	let layoutName = $('#grid-save-columns-form input').val();

	if (layoutName === '') {
		staticNotification.error('Název rozložení nesmí být prázdný.');
		return false;
	}

	var layoutId = (actualGridLayoutSettingsId === null) ? 0 : actualGridLayoutSettingsId;

	const formData = new FormData();
	formData.append('settings', JSON.stringify({
		sorting: sortModel,
		columns: columnState,
		groups: columnGroupState,
	}));
	formData.append('identifier', gridDataUrl);
	formData.append('name', layoutName);
	formData.append('_do', 'saveLayout');

	najaGlobal.makeRequest('POST', '/core/user/grid-settings/detail/' + layoutId, formData);

	return false;
}
